import {ImageInPaint} from "../../components/my_tools/ai_inpaint/imageInPaint";

interface IAIInPaint{
    globalTextColor: string;
}
export const AIInPaint: React.FC<IAIInPaint> = ({globalTextColor}) => {
    return (
        <div className={`text-[${globalTextColor}]`}>
            <ImageInPaint />
        </div>
    );
}
